import React, { useCallback, useEffect, useRef, useState } from 'react';
import Header from './Header';
import TabNav from '../Common/Form/Tab/TabNav';
import TabContextProvider from '../Common/Form/Tab/TabContext';
import TabContent from '../Common/Form/Tab/TabContent';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import Success from './Success';
import { clean } from '../Common/Form';
import axios from 'axios';

const sessionsById = (sessions) => {
    const data = {};

    Object.values(sessions).forEach((day) => {
        Object.entries(day).forEach(([, trackedSessions]) => {
            trackedSessions.forEach((session) => {
                data[session.sessionId] = session;
            });
        });
    });

    return data;
};

const EventRegistration = () => {
    const [event, setEvent] = useState(null);
    const [sessions, setSessions] = useState(null);
    const [hasSessions, setHasSessions] = useState(true);
    const [user, setUser] = useState(null);
    const [vendorShare, setVendorShare] = useState(false);
    const [globalError, setGlobalError] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [successMessage, setSuccessMessage] = useState();

    useEffect(() => {
        fetch('/actions/auth/api/fetch-user-info')
            .then((response) => response.json())
            .then((data) => setUser(data))
            .then(() => {
                const params = new URLSearchParams({ id: window.location.pathname.split('/').slice(-1)[0] });
                fetch(`/actions/event-registrations/register/fetch-event-info?${params}`)
                    .then((response) => response.json())
                    .then((data) => {
                        setEvent(data);

                        return data;
                    });
            });
    }, [setEvent, setUser]);

    if (sessions === null && event !== null) {
        setSessions(sessionsById(event.sessions));
        setHasSessions(Object.keys(event.sessions).length > 0);
    }

    const headingRef = useRef(null);

    const onSubmit = useCallback(() => {
        setIsSubmitting(true);

        fetch('/actions/event-registrations/register', {
            method: 'POST',
            headers: {
                'X-CSRF-Token': window.token,
            },
            body: new URLSearchParams({
                event_id: event.id,
                sessions: JSON.stringify(
                    Object.values(sessions)
                        .filter((session) => session.isSelected)
                        .map((session) => {
                            const obj = {
                                id: session.id,
                                sessionId: session.sessionId,
                            };
                            if (session.additionalInformation) {
                                obj.additional = session.additionalInformation;
                            }
                            return obj;
                        })
                ),
                additionalInfo: '',
                user: JSON.stringify({
                    email: user.email,
                    firstName: clean(user.firstName),
                    lastName: clean(user.lastName),
                    nickname: clean(user.nickname),
                    firm: user.acct,
                    jobTitle: clean(user.jobTitle),
                    phone: user.phone,
                    timezone: user.timezone,
                }),
                vendorShare: +vendorShare,
            }),
        })
            .then((r) => r.json())
            .then((d) => {
                setIsSubmitting(false);
                if (d.status === 'Success') {
                    setSuccessMessage(d.message);
                    axios.get('/actions/queue/run');
                } else if (d.status === 'Error') {
                    setGlobalError(d.message);
                }
            })
            .catch((err) => {
                setIsSubmitting(false);
                setGlobalError('Something went wrong');
            });
    }, [sessions, event, user, vendorShare]);

    return (
        <section className="registration">
            {!!successMessage && <Success user={user} event={event} sessions={sessions} message={successMessage} />}
            {!successMessage && (
                <span>
                    <Header ref={headingRef} user={user} event={event} />
                    <div className="registration__form container">
                        <TabContextProvider>
                            <TabNav steps>
                                {!!hasSessions && (
                                    <span>
                                        Choose
                                        <br />
                                        Sessions
                                    </span>
                                )}
                                <span>
                                    Verify
                                    <br />
                                    Registration
                                </span>
                            </TabNav>
                            <TabContent>
                                {!!hasSessions && (
                                    <StepOne
                                        ref={headingRef}
                                        event={event}
                                        sessions={sessions}
                                        setSessions={setSessions}
                                    />
                                )}
                                <StepTwo
                                    user={user}
                                    event={event}
                                    setUser={setUser}
                                    vendorShare={vendorShare}
                                    setVendorShare={setVendorShare}
                                    onSubmit={onSubmit}
                                    globalError={globalError}
                                    hasSessions={hasSessions}
                                />
                            </TabContent>
                        </TabContextProvider>
                    </div>
                </span>
            )}
        </section>
    );
};

EventRegistration.propTypes = {};

export default EventRegistration;
